const africaCitiesOverview = [
  {
    "code": "ZA",
    "city": "Cape Town",
    "country": "South Africa",
    "price": 5600
  },
  {
    "code": "MU",
    "city": "Grand Baie",
    "country": "Mauritius",
    "price": 5000
  },
  {
    "code": "ZA",
    "city": "Plettenberg Bay",
    "country": "South Africa",
    "price": 2400
  },
  {
    "code": "ZA",
    "city": "Hermanus",
    "country": "South Africa",
    "price": 2300
  },
  {
    "code": "MA",
    "city": "Marrakech",
    "country": "Morocco",
    "price": 2200
  },
  {
    "code": "ZA",
    "city": "Umhlanga",
    "country": "South Africa",
    "price": 2000
  },
  {
    "code": "ZA",
    "city": "Sandton (in Johannesburg)",
    "country": "South Africa",
    "price": 1800
  },
  {
    "code": "MA",
    "city": "Tangier",
    "country": "Morocco",
    "price": 1600
  },
  {
    "code": "EG",
    "city": "Cairo",
    "country": "Egypt",
    "price": 1500
  },
  {
    "code": "MA",
    "city": "Casablanca",
    "country": "Morocco",
    "price": 1400
  }
];


export { africaCitiesOverview };